import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { makeRequest } from '../../api/api';
import { commonMoodlePayload } from '../../config';
import { METHODS, SERVICES } from '../../api/constants';

export const fetchAllNotifcation = createAsyncThunk(
  'appFeatureLaunchPopup/fetchAllNotification',
  async (param) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.GET,
        { ...param, ...commonMoodlePayload }
      );
      return { data: response.data };
    } catch (e) {}
  }
);
export const postAllNotification = createAsyncThunk(
  'appFeatureLaunchPopup/postFeatureLaunch',
  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.POST,
        { ...param, ...commonMoodlePayload }
      );
      return { data: response.data };
    } catch (e) {}
  }
);

export const postAllNotificationNewFeatureAndGeneral = createAsyncThunk(
  'appFeatureLaunchPopup/postAllNotificationNewFeatureAndGeneral',

  async (param, thunkApi) => {
    try {
      const response = await makeRequest(
        SERVICES.MOODLE_SERVICE,
        '',
        METHODS.POST,
        { ...param, ...commonMoodlePayload }
      );
      return { data: response.data };
    } catch (e) {}
  }
);

export const featureLaunchPopupSlice = createSlice({
  name: 'featureLaunchPopupSlice',
  initialState: {
    loading: false,
    allNotificationData: [],
    unreadCount: 0,
    allFeatureLaunchData: []
  },
  reducers: {
    updateNewFeatureData: (state, action) => {
      state.allFeatureLaunchData = action.payload;
    }
    // data?.component === 'feature_alert_mobile'
  },
  extraReducers: (builder) => {
    builder.addCase(fetchAllNotifcation.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchAllNotifcation.fulfilled, (state, action) => {
      state.loading = false;
      state.allNotificationData = action.payload?.data.notifications || [];
      state.unreadCount = action.payload?.data?.unreadcount || 0;
    });
    builder.addCase(fetchAllNotifcation.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(postAllNotification.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(postAllNotification.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(postAllNotification.rejected, (state) => {
      state.loading = false;
    });
  }
});
export const { updateNewFeatureData } = featureLaunchPopupSlice.actions;
export default featureLaunchPopupSlice.reducer;
